var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",attrs:{"title":_vm.title},on:{"click":function($event){$event.preventDefault();_vm.to && _vm.handleTo()}}},[_vm._t("default"),(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }